import { systemValueLabel } from '../../../generic/systemValues/systemValueLabel'

// PartLifecycleGroup -> label for the parts grid (RN66, T5b, plan-jupiter.md §1.1).
//
// Presentation-only: the group is always computed IN SUN (N12,
// `PartLifecycleGroupPolicy.group(status, result)`) from status AND result together — this module
// only turns that already-decided value into text. It never re-derives the group from `status`
// alone (the shared invariant of historia #97, also why `generic/utilities/partResultLabel.js`
// deliberately does not accept `status`): the two datums stay independent all the way to the
// grid (S215).
//
// ⚠️⚠️ S416 — SON CINCO, Y `NOT_STARTED` ES EL QUE FALTABA. `RAW` y `WORKING` caían LOS DOS en
// `IN_PROGRESS`, así que las piezas todavía sin tocar se anunciaban «En curso»: 19 de las 32 de la
// base del PO. No era un rótulo impreciso — era el defecto de paridad contra el diálogo antiguo,
// que sí distinguía «sin empezar» de «en curso».
//
// 📌 Y el dato de Sun que evita depurar de más: **`IN_PROGRESS` ha dejado de ser el cajón de
// sastre**. Cada `PartStatusEnum` nombra su grupo en un `switch` explícito y un estado desconocido
// LANZA en vez de heredar el último. Si aquí llega un grupo inesperado NO es una pieza mal
// clasificada: es un valor nuevo del backend, y hay que añadirlo a este mapa a conciencia.
//
// Story 204 (RN1.5): NOT_STARTED and IN_PROGRESS are translated by their own code (which carries the text of
// `Parts not started` / `Parts in progress`); the three below keep their own key (P1-bis) for the reason that follows.
// ⚠️ LAS CLAVES i18n SON PROPIAS (`Parts finished`, no `Finished`), y no es cosmética. Los rótulos
// genéricos `Finished`/`In progress`/`Rejected`/`Cancelled` los comparten media docena de pantallas
// que hablan de UNA cosa en singular — en castellano «Finalizado», «Rechazada», «Cancelada». Aquí
// se nombra un CONJUNTO DE PIEZAS («terminadas», «rechazadas», «canceladas»), que es otro texto.
// Atarlos obligaría a reescribir el valor compartido para que este bloque leyera bien, y eso
// cambiaría el rótulo de las otras pantallas sin que nadie lo pida. Clave propia, valor inglés el que
// el PO quiere leer. (`partTrackStepState.js` tuvo también claves propias hasta el 23/09 y ya no: allí
// sí era el mismo estado que la operación.)
const PART_LIFECYCLE_GROUP_LABEL_KEYS = {
  FINISHED: 'Parts finished',
  REJECTED: 'Parts rejected',
  CANCELLED: 'Parts cancelled'
}

// Los cinco grupos EN SU ORDEN DE LECTURA: del principio de la vida de la pieza al final, y las
// canceladas al cierre. Vive aquí, junto al mapa, porque el orden es conocimiento de este enum:
// el desplegable, los recuentos y la rejilla lo leen de aquí en vez de repetir la lista tres
// veces, que es como una de las tres se queda sin el grupo nuevo.
export const PART_LIFECYCLE_GROUPS = ['NOT_STARTED', 'IN_PROGRESS', 'FINISHED', 'REJECTED', 'CANCELLED']

/**
 * @param {string} lifecycleGroup one of NOT_STARTED|IN_PROGRESS|FINISHED|REJECTED|CANCELLED, as
 *   Sun sends it.
 * @param {function(string): string} t_ Translation function from useSmartTranslation().
 * @returns {string} the localized group label.
 */
export const partLifecycleGroupLabel = (lifecycleGroup, t_) =>
  systemValueLabel(t_, 'PartLifecycleGroup', lifecycleGroup || '', PART_LIFECYCLE_GROUP_LABEL_KEYS)

export { PART_LIFECYCLE_GROUP_LABEL_KEYS }
